import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import appLogoHeader from '../../assets/appLogoHeader.png';
import LanguageSelector from './LanguageSelector';
import { useLanguage } from '../../context/LanguageContext';

function Header() {
  const { t } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <img src={appLogoHeader} alt="Logo Quizzer" className="logo-img" />
            </Link>
          </div>
          
          <div className={`nav-container ${menuOpen ? 'open' : ''}`}>
            <div className="nav-row">
              <div className="center-navigation">
                <nav className="navigation">
                  <ul>
                    <li>
                      <Link to="/" className={isActive('/') ? 'active' : ''}>
                        {t('accueil')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" className={isActive('/about') ? 'active' : ''}>
                        {t('apropos')}
                      </Link>
                    </li>
                    <li className="blog-menu-item">
                      <div className="blog-link-container">
                        <span className="new-badge">NEW</span>
                        <Link to="/blog" className={isActive('/blog') ? 'active' : ''}>
                          {t('blog')}
                        </Link>
                      </div>
                    </li>
                    <li>
                      <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>
                        {t('contact')}
                      </Link>
                    </li>
                    <li>
                      <Link to="/cgu" className={isActive('/cgu') ? 'active' : ''}>
                        {t('cgu')}
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              
              <div className="right-actions desktop-only">
                <div className="header-actions inline-actions">
                  <LanguageSelector />
                </div>
              </div>
            </div>
            
            <div className="mobile-actions">
              <LanguageSelector />
            </div>
          </div>
          
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <span className={`hamburger ${menuOpen ? 'active' : ''}`}></span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header; 